import _isEmpty from 'lodash/isEmpty';
import _every from 'lodash/every';
import _filter from 'lodash/filter';
import _some from 'lodash/some';
import _isNumber from 'lodash/isNumber';

var isEmptyColumn = function isEmptyColumn(columnValue) {
  return !columnValue && columnValue !== 0 || !_isNumber(columnValue) && _isEmpty(columnValue);
};

export var isEmptyRow = function isEmptyRow(row) {
  if (_isEmpty(row)) return true;
  return _every(row, isEmptyColumn);
};
export var isRowNotEmpty = function isRowNotEmpty(row) {
  return !isEmptyRow(row);
};
export var getNonEmptyRows = function getNonEmptyRows(rows) {
  return _filter(rows, isRowNotEmpty);
};
export var isTableNotEmpty = function isTableNotEmpty(rows) {
  return _some(rows, isRowNotEmpty);
};